import { useMinAndMaxPeopleNumPerRoom } from "@/components/features/items/edit/plan/_shared/ui/components/min-and-max-people-num/hooks";

import { useProductDayTripPlanFormModelContext } from "../../../../context";

export const useDayTripPlanMinAndMaxPeopleNumPerRoom = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { minimumPeopleNumPerRoom, maxPeopleNumPerRoom } = viewModel;

	return useMinAndMaxPeopleNumPerRoom({
		minimumPeopleNumPerRoom,
		maxPeopleNumPerRoom,
		onSetViewModel,
	});
};
